import { Marketing, MarketingPage } from '@/api/api.schemas';
import { useMediaQuery } from '@/hooks/use-media-query';
import { useBranding } from '@/outlets/branding-outlet';
interface MarketingSpotProps {
  page: keyof Marketing;
  spot: keyof MarketingPage;
  className?: string;
}

export function MarketingSpot({ page, spot, className }: MarketingSpotProps) {
  const { marketing } = useBranding();
  const isMobile = useMediaQuery('--screen-md');

  const spotContent = marketing?.[page]?.[spot];

  if (!spotContent) return null;

  const content = isMobile ? spotContent.mobile : spotContent.desktop;

  if (!content) return null;

  return <div className={className} dangerouslySetInnerHTML={{ __html: content }} />;
}
